/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_TitleInputs */

const es_billing_events_title = /** @type {(inputs: Billing_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de facturación`)
};

const en_billing_events_title = /** @type {(inputs: Billing_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing events`)
};

/**
* | output |
* | --- |
* | "Billing events" |
*
* @param {Billing_Events_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_title = /** @type {((inputs?: Billing_Events_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_title(inputs)
	return en_billing_events_title(inputs)
});
export { billing_events_title as "billing.events.title" }